import { render, staticRenderFns } from "./RecordQuery.vue?vue&type=template&id=4f0f2600&scoped=true&"
import script from "./RecordQuery.vue?vue&type=script&lang=js&"
export * from "./RecordQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f2600",
  null
  
)

export default component.exports